import { useSearchParams } from "react-router-dom";

export interface NetworkFiltersState {
  location?: string;
  nationality?: string;
  gender?: string;
  verificationStatus?: string;
  limit?: number;
  offset?: number;
  role?: string;
}

export const useNetworkFiltersState = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const network = searchParams.get("network") || "followers";
  const filters: NetworkFiltersState = {
    location: searchParams.get("location") || undefined,
    nationality: searchParams.get("nationality") || undefined,
    gender: searchParams.get("gender") || undefined,
    verificationStatus: searchParams.get("verificationStatus") || undefined,
    limit: searchParams.get("limit") ? parseInt(searchParams.get("limit")!) : 9,
    offset: searchParams.get("offset") ? parseInt(searchParams.get("offset")!) : 0,
    role: searchParams.get("role") || undefined,
  };

  const queryParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined) queryParams.append(key, value.toString());
  });
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";

  const updateFilters = (key: keyof NetworkFiltersState, value: string) => {
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set(key, value);
    } else {
      newParams.delete(key);
    }
    setSearchParams(newParams);
  };

  const clearFilters = () => {
    const newParams = new URLSearchParams(searchParams);
    Object.keys(filters).forEach((key) => {
      newParams.delete(key);
    });
    setSearchParams(newParams);
  };

  const hasActiveFilters = Object.values(filters).some(Boolean);

  return {
    network,
    filters,
    queryString,
    hasActiveFilters,
    updateFilters,
    clearFilters,
  };
};
